import React from 'react'

/** ID of the main content landmark targeted by SkipToContent. */
export const MAIN_CONTENT_ID = 'main-content'

type Props = {
  contentId?: string
}

/**
 * Accessibility link that allows keyboard users to skip past navigation
 * and jump directly to the main content area. Positioned off-screen above
 * the viewport and translated into view on focus — avoids the sr-only/clip
 * technique which some Chromium builds skip during Tab navigation.
 */
const SkipToContent = ({ contentId = MAIN_CONTENT_ID }: Props) => {
  return (
    <a
      href={`#${contentId}`}
      className="fixed top-4 left-4 z-[9999] -translate-y-[200%] rounded bg-white px-4 py-2 text-sm font-medium text-blue-700 shadow-lg ring-2 ring-blue-500 transition-transform focus:translate-y-0"
    >
      Skip to content
    </a>
  )
}

export default React.memo(SkipToContent)
